// Malay translations
export const ms: Record<string, string> = {
  'menu.dashboard': 'Papan Pemuka', 'menu.orderNew': 'Pendaftaran Produk', 'menu.customers': 'Pelanggan', 'menu.products': 'Produk', 'menu.users': 'Pengguna', 'menu.settings': 'Tetapan', 'menu.logout': 'Log Keluar',
  'dashboard.title': 'Papan Pemuka', 'dashboard.todaySales': 'Jualan Hari Ini', 'dashboard.totalOrders': 'Jumlah Pesanan', 'dashboard.newOrder': 'Pesanan Baru', 'dashboard.newCustomer': 'Pelanggan Baru',
  'order.title': 'Pesanan Baru', 'order.customer': 'Pelanggan', 'order.products': 'Produk', 'order.quantity': 'Kuantiti', 'order.price': 'Harga', 'order.total': 'Jumlah', 'order.payment': 'Bayaran', 'order.cash': 'Tunai', 'order.card': 'Kad',
  'users.title': 'Pengguna', 'users.name': 'Nama', 'users.email': 'E-mel', 'users.role': 'Peranan', 'users.edit': 'Edit', 'users.delete': 'Padam',
  'common.yes': 'Ya', 'common.no': 'Tidak', 'common.cancel': 'Batal', 'common.save': 'Simpan', 'common.search': 'Cari', 'common.loading': 'Memuatkan...',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy', 'login.login': 'Log Masuk', 'login.enterPin': 'Masukkan PIN', 'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.title': 'Pendaftaran', 'signup.createAccount': 'Cipta Akaun', 'signup.email': 'E-mel', 'signup.phone': 'Telefon',
  'expenses.expenseType': 'Jenis Perbelanjaan',
  'expenses.allBranches': 'Semua Cawangan',
  'expenses.noBranch': 'Tiada Cawangan',
  'expenses.allTypes': 'Semua Jenis',
  'expenses.categoryBy': 'Mengikut Kategori',
  'expenses.records': 'rekod',
  'expenses.exportExcel': 'Excel',
  'expenses.excelError': 'Fail Excel tidak dapat dibuat',
  'expenses.branchSelect': 'Pilih cawangan',
  'expenses.noBranchSelected': '— Tiada cawangan dipilih —',
  'expenses.myBranch': 'Cawangan saya',
  'expenses.canOnlyDeleteToday': 'Anda hanya boleh memadam perbelanjaan yang dimasukkan hari ini.',
  'users.eleman': 'Pekerja',
  'menu.reportsAndAccounting': 'Laporan & Perakaunan',
  'menu.systemAndCommunication': 'Sistem & Komunikasi',
};
